/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PrintProofStatus {
    PROCESSING = 'processing',
    PENDING_REVIEW = 'pending_review',
    REVIEWED = 'reviewed',
}
